import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteDefaultEventConsentDocument,
  DeleteDefaultEventConsentMutation,
} from "src/generated-gql/graphql";

const deleteDefaultEventConsentBulkAction: BulkAction = {
  location: "default-event-consent-table",
  label: "Delete selected default event consent contents",
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission: (userPermissions) => {
    return userPermissions.includes("DeleteEventContentConsent");
  },
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete selected default event consent contents",
        body: `Are you sure you want to delete ${selection.length} default event consent contents?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteDefaultEventConsentMutation>[] =
            [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteDefaultEventConsentDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteDefaultEventConsentBulkAction };
